export default __webpack_public_path__ + "static/media/testimonial-2.dbc8a3e9.jpeg";